import type { ErrorDetails } from '../types';

export class DiceReceiverError extends Error implements ErrorDetails {
    public code: string;
    public key: string;
    public title: string;

    constructor(title: string, message: string, code: string, key: string) {
        super(message);
        this.name = 'DiceReceiverError';
        this.title = title;
        this.code = code;
        this.key = key;
    }
}
